import styled from 'styled-components'

export const StereotypeTitle = styled.p`
	margin: 1rem 0 1rem 2rem;
`
